/*
 * @Author: Latte
 * @Date: 2021-08-16 15:04:43
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-18 15:56:27
 * @FilePath: \Siui.Cloud.Medical.Web\src\config\tableConfig\systemMgt\diagnosticMgt\diagnosticJoinTeam.js
 */

// 入团申请表格配置
export const joinTeamConf = Object.freeze({
	tableColumnOpt: [
		{
			label: "申请时间",
			prop: "createTime",
			width: "200",
			hasFormatter: true,
			formatter: function(val) {
				return new Date(val).toLocaleString();
			},
		},
		{
			label: "团队ID",
			prop: "teamID",
			width: "50",
		},
		{
			label: "团队名称",
			prop: "teamName",
			width: "150",
		},
		{
			label: "工作地点",
			prop: "workCity",
			width: "150",
		},
		{
			label: "所属单位",
			prop: "company",
			width: "200",
		},
		{
			label: "申请人名字",
			prop: "firstName",
			width: "150",
		},
		{
			label: "申请人ID",
			prop: "createUserID",
			width: "150",
		},
	],
});
